export default "__VITE_ASSET__Bxr_uY3Q__"